import { useTranslation } from '@klv/hooks/useTranslation';

import { generateClassName } from '@klv/shared/utils/functions';
import Icon from '@klv/atoms/icon';
import { Anchor } from '@klv/atoms/anchor';

import * as styles from './styles/blogAuthor.module.scss';
import type { IBlogAuthorThumbnail } from './types';

const BlogHeroAuthorThumbnail = ({
  authors,
  cardImageExists,
  readTime = 0,
}: IBlogAuthorThumbnail) => {
  const { t } = useTranslation();
  const hasMultipleAuthors = authors && authors.length > 1;

  return (
    <div className={generateClassName([styles.row, (cardImageExists ? '' : styles.noImage)])}>
      <div className={styles.authorImageFrame}>
        {authors && authors[0]?.image && !hasMultipleAuthors ? (
          <img
            alt={(authors[0]?.image) ? `${t('molecules_blogAuthor_authorAltText')} ${authors[0]?.name}` : `${t('molecules_blogAuthor_defaultAuthorAltText')}`}
            className={styles.authorImage}
            sizes={authors[0]?.image?.sizes}
            src={authors[0]?.image?.sourceUrl}
            srcSet={authors[0]?.image?.srcSet}
          />
        ) : (
          <Icon
            className={styles.klaviyoLogo}
            iconName="BugMarkFilled"
            role="img"
            aria-label={`${t('molecules_blogAuthor_authorAltText')}`}
          />
        )}
      </div>
      <div className={styles.authorDetails}>
        {authors && authors.map(({ link, name }) => (
          <Anchor
            key={`${name}${link}`}
            className={generateClassName([styles.authorName, 'formRegular'])}
            href={link}
          >
            {name}
          </Anchor>
        ))}
        {Boolean(readTime) && (
          <div className="formRegular">
            {readTime} {`${t('molecules_blogAuthor_minRead')}`}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogHeroAuthorThumbnail;
